// extracted by mini-css-extract-plugin
module.exports = {"container":"Finish_container__3uuEA","title":"Finish_title__2Bobx","subtitle":"Finish_subtitle__2th_A","link":"Finish_link__1tOs-"};